import styled from '@emotion/styled';
import { Typography as _Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreativeFormat } from '../../../../generated/graphql';
import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import mq from '../../../styleUtility/mediaquery';

const FormatByAttribute: FC<{
  creativeFormat: CreativeFormat;
}> = ({ creativeFormat }) => {
  const aspectRatio = creativeFormat.attribute.aspectRatio ? creativeFormat.attribute.aspectRatio.aspectRatio : null;
  const size = creativeFormat.attribute.aspectRatio ? creativeFormat.attribute.aspectRatio.size : null;
  return (
    <Root>
      {aspectRatio && size ? (
        <Typography variant="body2">
          {size.width * size.height > 0 ? (
            `${aspectRatio.width}:${aspectRatio.height}（${size.width}:${size.height}）`
          ) : (
            <FormattedMessage id="creative_format.aspect_ratio.nullable" />
          )}
        </Typography>
      ) : null}
      {creativeFormat.attribute.playbackTime ? (
        <Typography variant="body2">
          <FormattedMessage
            id="creative_format.playback_time"
            values={{
              seconds: creativeFormat.attribute.playbackTime.seconds,
            }}
          />
        </Typography>
      ) : null}
    </Root>
  );
};

const Typography = styled(_Typography)`
  font-size: 0.775rem;
  ${mq('sp')} {
    font-size: 0.575rem;
  }
`;

const RequiredPoint = styled(Typography)`
  ${flexibleLayoutContainer({
    alignItems: 'center',
  })}
  font-weight: 700px;
`;

RequiredPoint.defaultProps = { variant: 'body1', color: 'primary' };

const Root = styled('div')`
  ${flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
  })}
  margin-top: 5px;
  margin-left: ${SPACING_UNIT}px;
`;

export default FormatByAttribute;
